const state = {
 add_modal: false,
 view_modal: false,
 view_list_modal: false,
 edit_modal: false,
 id: null,
 name: null,
 type: null,
 contacts: null,
 
 reload_notes: false
};
const actions = {};

const mutations = {
 SHOW_ADD_NOTE_MODAL(state, payload) {
  state.add_modal = true;
  state.edit_modal = false;
  state.view_modal = false;
  state.view_list_modal = false;
  state.id = payload.id;
  state.name = payload.name;
  state.type = payload.type;
  state.contacts = payload.contacts;
 },
 SHOW_VIEW_NOTE_MODAL(state, payload) {
  state.add_modal = false;
  state.edit_modal = false;
  state.view_modal = true;
  state.view_list_modal = false;
  state.id = payload.id;
  state.name = payload.name;
  state.type = payload.type;
  state.contacts = payload.contacts
 },
 SHOW_VIEW_NOTES_LIST_MODAL(state, payload) {
    state.add_modal = false;
    state.edit_modal = false;
    state.view_modal = false;
    state.view_list_modal = true;
    state.id = payload.id;
    state.name = payload.name;
    state.type = payload.type;
    state.contacts = payload.contacts
   },


 SHOW_EDIT_NOTE_MODAL(state, payload) {
  state.add_modal = false;
  state.edit_modal = true;
  state.view_modal = false;
  state.view_list_modal = false;
  state.id = payload.id;
  state.name = payload.name;
  state.type = payload.type;
  state.contacts = payload.contacts
 },
 HIDE_NOTE_MODALS(state) {
  state.add_modal = false;
  state.edit_modal = false;
  state.view_modal = false;
  state.view_list_modal = false;
  state.id = null;
  state.name = null;
  state.type = null;
  state.contacts = null;
 },
 RELOAD_NOTES(state, payload) {
  state.reload_notes = payload.action;
 }
};

export default {
 state,
 actions,
 mutations
}
